/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */

import {
  AddNewPackageData,
  AddNewPlanDiscountBody,
  AddNewRetry,
  AddNewSuccessData,
  AddonPackageData,
  CardData,
  ChangePlanData,
  MainPackageData,
  OverViewData,
  TransactionData,
  UpdateDeleteParams,
  UpdateInvoiceParams,
} from './types';

import axiosInstance from 'services/common/instance';

export const getOverViewService = async (): Promise<OverViewData> => {
  const response = await axiosInstance.get('billings/over-view');
  return response.data.data;
};

export const getTransactionService = async (): Promise<TransactionData[]> => {
  const response = await axiosInstance.get('billings/transactions');
  return response.data.data;
};

export const updateInvoiceInfoService = async (body: UpdateInvoiceParams) => {
  const { code, ...rest } = body;
  const response = await axiosInstance.put(
    `billings/update-invoice-info/${code}`,
    rest
  );
  return response.data.data;
};

export const cancelSubcriptionService = async (code: string) => {
  const response = await axiosInstance.put(
    `billings/cancel-subcription/${code}`
  );
  return response.data.data;
};

export const downloadTransactionService = async () => {
  const response = await axiosInstance.get('billings/download-transaction');
  return response.data.data;
};

export const renewSubcriptionService = async ({
  code,
  returnUrl,
  cancelUrl,
  cardTokenId,
}: {
  code: string;
  returnUrl?: string;
  cancelUrl?: string;
  cardTokenId?: number | null;
}) => {
  const response = await axiosInstance.put(
    `billings/renew-subcription/${code}`,
    { returnUrl, cancelUrl, cardTokenId }
  );
  return response.data.data;
};

export const renewAddOnService = async ({
  code,
  returnUrl,
  cancelUrl,
  cardTokenId
}: {
  code: string;
  returnUrl?: string;
    cancelUrl?: string;
   cardTokenId?: number | null;
}) => {
  const response = await axiosInstance.put(
    `billings/plan/renew-add-on/${code}`,
    { returnUrl, cancelUrl, cardTokenId }
  );
  return response.data.data;
};

export const getCardService = async (): Promise<CardData[]> => {
  const response = await axiosInstance.get('billings/cards');
  return response.data.data;
};

export const addCardService = async ({
  code,
  returnUrl,
  cardIndex,
}: {
  code: string;
  returnUrl: string;
  cardIndex: number;
}) => {
  const response = await axiosInstance.post(`billings/cards/add/${code}`, {
    returnUrl,
    cardIndex,
  });
  return response.data.data;
};

export const deleteCardService = async ({
  code,
  id,
}: {
  code: string;
  id: number;
}) => {
  const response = await axiosInstance.delete(
    `billings/cards/${code}/destroy/${id}`
  );
  return response.data.data;
};

export const renewSuccessService = async ({
  token,
  transactionCode,
  errorCode,
  cancel,
  merchantSideUserId,
  checksum,
  data,
}: AddNewSuccessData) => {
  const response = await axiosInstance.post('billings/renew-success', {
    transactionCode,
    errorCode,
    cancel,
    merchantSideUserId,
    checksum,
    data,
    token,
  });
  return response.data.data;
};

export const renewFailService = async ({
  token,
  transactionCode,
  errorCode,
  cancel,
  merchantSideUserId,
  checksum,
  data,
}: AddNewSuccessData) => {
  const response = await axiosInstance.post('billings/renew-fail', {
 transactionCode,
    errorCode,
    cancel,
    merchantSideUserId,
    checksum,
    data,
    token,
});
  return response.data.data;
};

export const addNewPackageService = async (body: AddNewPackageData) => {
  const response = await axiosInstance.post(
    'billings/plan/add-new-package',
    body
  );
  return response.data.data;
};

export const getPlanMainPackageService = async ({
  page,
}: {
  page: number;
}): Promise<{
  data: MainPackageData[];
  meta: {
    totalPages: number;
    limit: number;
    total: number;
    page: number;
  };
}> => {
  const response = await axiosInstance.get(
    `billings/plan/main-packages?page=${page}&limit=100`
  );
  return response.data;
};

export const getPlanAddonsPackageService = async ({
  page,
}: {
  page: number;
}): Promise<{
  data: AddonPackageData[];
  meta: {
    totalPages: number;
    limit: number;
    total: number;
    page: number;
  };
}> => {
  const response = await axiosInstance.get(
    `billings/plan/add-on-packages?page=${page}&limit=100`
  );
  return response.data;
};

export const addNewSuccessService = async (body: AddNewSuccessData) => {
  const response = await axiosInstance.post('billings/plan/success', body);
  return response.data.data;
};

export const addNewFaildService = async (body: AddNewSuccessData) => {
  const response = await axiosInstance.post('billings/plan/cancel', body);
  return response.data.data;
};

export const changePlanService = async (body: ChangePlanData) => {
  const response = await axiosInstance.post('billings/plan/change-plan', body);
  return response.data.data;
};

export const changePlanDiscountService = async (): Promise<{
  discountAmount: number;
  discountDay: number;
}> => {
  const response = await axiosInstance.get(
    'billings/plan/change-plan/discount'
  );
  return response.data.data;
};

export const addNewPlanDiscountService = async (
  body: AddNewPlanDiscountBody
): Promise<{
  discountAmount: number;
  discountDay: number;
  servicePackageAddOns: {
    discountAmount?: number;
    maxQty?: number;
    quantity: number;
    servicePackageAddOnId: number;
    unit: number;
  }[];
}> => {
  const response = await axiosInstance.post(
    'billings/plan/add-new-package/discount',
    body
  );
  return response.data.data;
};

export const addNewPackageRetryService = async (
  token: string
): Promise<AddNewRetry> => {
  const response = await axiosInstance.get(
    `billings/plan/add-new-package/retry/${token}`
  );
  return response.data.data;
};

export const changePlanRetryService = async (
  token: string
): Promise<AddNewRetry> => {
  const response = await axiosInstance.get(
    `billings/plan/change-plan/retry/${token}`
  );
  return response.data.data;
};

export const updateDeleteService = async (body: UpdateDeleteParams) => {
  const { code, ...rest } = body;
  const response = await axiosInstance.post(`billings/plan/change-plan/update-delete-storage/${code}`, rest);
  return response.data.data;
};

export const cancelAddOnService = async (code: string) => {
  const response = await axiosInstance.put(
    `billings/plan/cancel-add-on/${code}`
  );
  return response.data.data;
};
